<template>
  <div class="login">
    <div class="loginContainer">
      <div class="loginContainerLogo">
        <img src="../../assets/logo.png" />
      </div>
      <div class="loginContainerTitle">Login to your account</div>
      <div class="loginContainerFields">
        <v-text-field
          type="tel"
          dense
          outlined
          v-bind:disabled="state === 1"
          v-model="phone_number"
          :label="$t('phone_number')"
          v-bind:rules="phoneNumberRules"
          ref="phone_number"
          v-bind:return-masked-value="false"
          prefix="+998"
          color="#3E6187"
          v-mask="mask"
          v-on:keyup.enter="signin"
        />
        <v-text-field
          type="tel"
          v-if="state == 1"
          :autofocus="state == 1"
          v-model="sms_code"
          counter="4"
          dense
          outlined
          color="#3E6187"
          :label="$t('verificationCode')"
          ref="verify"
          v-mask="code_mask"
          v-bind:rules="smsCodeRules"
          v-on:keyup.enter="verify"
        />
        <button v-if="state === 0" v-on:click="signin">
          {{ $t("getCode") }}
        </button>
        <button v-if="state === 1" v-on:click="verify">
          {{ $t("Enter") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      mask: "(##) ### - ## - ##",
      code_mask: "####",
      sms_code: "",
      phone_number: null,
      state: 0,
      phoneNumberRules: [(value) => !!value || "Required"],
      smsCodeRules: [(value) => !!value || "Required"],
    };
  },
  mounted() {
    if (this.query && this.query.phone_number) {
      this.phone_number = this.query.phone_number;
      this.signin();
    }
  },
  methods: {
    async signin() {
if(!this.phone_number && this.phone_number?.length === 18) return
        const response = await this.$communicator("signin", {
          params: {
            phone_number: this.$communicator.clear_phone_number(
              this.phone_number
            ),
          },
        });

      if (response.status === 200) {
        if (response.data.statusCode === 200) {
          this.state = 1;
        }
        if (response.data.statusCode === 420) {
          const phone_number = this.phone_number;
          this.phoneNumberRules.push(
            (value) => value !== phone_number || "Has no registered yet!"
          );
          this.$refs["phone_number"].validate();
        }
      }
    },
    async verify() {
      if(!this.sms_code) return
      const response = await this.$communicator("verify", {
        params: {
          phone_number: this.$communicator.clear_phone_number(
            this.phone_number
          ),
          sms_code: this.sms_code,
        },
      });
      if (response.status == 200) {
        if (response.data.statusCode == 422) {
          const sms_code = this.sms_code;
          this.smsCodeRules.push(
            (value) => value !== sms_code || "Incorrect sms code"
          );
          this.$refs["verify"].validate();
        }
        if (response.data.statusCode == 200) {
          this.$store.commit("user", response.data.data);
          this.$store.commit("lang", response.data.data.ui_language);
          if (this.$route.query["redirect"]) {
            window.location.href = this.$route.query["redirect"];
          } else window.location.href = "/";
        }
      }
    },
  },
};
</script>
